import React from 'react';
import ServiceCardStrech from '../../common/ServiceCardStrech';
import missionImage from '../../../assets/images/about/our-mission.webp';

const Mission = () => {
  const missionContent = {
    title: 'Our Mission',
    description: `To improve financial inclusion and literacy across Ghana by creating a transparent, accessible marketplace where consumers can easily find, compare, and apply for the financial products they need.

At SimFinance, we recognize the challenges many Ghanaians face when navigating the complex financial landscape. Traditional barriers such as geographic limitations, lack of financial education, and complicated application processes have historically prevented many citizens from accessing the financial tools necessary for economic advancement and security.

By eliminating information asymmetry, we empower consumers to make confident decisions based on their unique circumstances and goals.`,
    image: missionImage,
    hasGradient: false,
    isReversed: true,
    rounded: true,
  };

  return (
    <div className="bg-white">
      <ServiceCardStrech {...missionContent} />
    </div>
  );
};

export default Mission;